module.exports = __webpack_public_path__ + "img/Thereare.c7e91099.png";